<div class="document-details-view-container" *ngIf="documentObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="documentObject.recordId?.toString()">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).document.write || documentObject.type.key === FILE_TYPE_IDD_TRAINING_STATEMENT || documentObject.type.key === FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM"
      (click)="modify()" mat-stroked-button color="primary"
    ><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).document.delete" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    <button [disabled]="!(userPermissions | async).document.read" (click)="download()" mat-stroked-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane pliku</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa pliku" [value]="documentObject.filename"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa dokumentu" [value]="documentObject.documentName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Typ dokumentu" [value]="documentObject.type?.name"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="documentObject.certDate">
              <div fxFlex="100">
                <app-detail header="Data wystawienia zaświadczenia" [value]="documentObject.certDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="documentObject.deviceProtocolDate">
              <div fxFlex="100">
                <app-detail header="Data przekazania/zwrotu urządzenia" [value]="documentObject.deviceProtocolDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="[FILE_TYPE_AUTHORIZATION].includes(documentObject.type.key) && (userPermissions | async).document.admin_root">
              <div fxFlex="50">
                <app-detail header="Link publiczny APK" [value]="publicLink"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[FILE_TYPE_ANOTHER_MULTI].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Informacje o dokumencie</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool fxFlex="33" header="Skan" [value]="documentObject?.documentInformationScan"></app-detail-bool>
                <app-detail-bool fxFlex="33" header="Oryginał" [value]="documentObject?.documentInformationOriginal"></app-detail-bool>
                <app-detail-bool fxFlex="33" header="Brak dokumentu" [value]="documentObject?.documentInformationDocumentMissing"></app-detail-bool>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_CONTRACT,
        FILE_TYPE_CONTRACT_TERMINATION,
        FILE_TYPE_ANNEX,
        FILE_TYPE_OFWCA_APPLICATION,
        FILE_TYPE_ANNEX_OFWCA_APPLICATION,
        FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
        FILE_TYPE_RECEIPT_PROTOCOL,
        FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS,
        FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE,
        FILE_TYPE_CONFIDENTIALITY_AGREEMENT,
        FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
        FILE_TYPE_ANNEX_LEAD,
        FILE_TYPE_ANNEX_AUTOMATIC_BILLING,
        FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING,
        FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING

      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Strona umowy" [value]="documentObject.contract.owner.name"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="documentObject.ofwca">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="documentObject.ofwca.fullName"
                            [link]="documentObject.ofwca ? ['/ofwca/szczegoly', documentObject.ofwca.uuid] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" *ngIf="documentObject.partner">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="documentObject.partner.shortName"
                            [link]="documentObject.partner ? ['/partnerzy/szczegoly', documentObject.partner.uuid] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Umowa"
                            [value]="documentObject.contract.type.name + ' (nr: ' + documentObject.contract.number + '), zawarta ' + (documentObject.contract.concludeDate | date:'y-MM-dd')"
                            [link]="documentObject.contract ? ['/umowy/szczegoly', documentObject.contract.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_DIPLOMA,
        FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA,
        FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
        FILE_TYPE_IDD_TRAINING_STATEMENT,
        FILE_TYPE_CONTRACT_WITH_EMPLOYEE
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>OFWCA</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.ofwca">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="documentObject.ofwca.fullName"
                            [link]="documentObject.ofwca ? ['/ofwca/szczegoly', documentObject.ofwca.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_CONTRACT_WITH_EMPLOYEE
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3> Umowy</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Umowa"
                            [value]="documentObject.contract.type.name + ' (nr: ' + documentObject.contract.number + '), zawarta ' + (documentObject.contract.concludeDate | date:'y-MM-dd')"
                            [link]="documentObject.contract ? ['/umowy/szczegoly', documentObject.contract.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="FILE_TYPE_IDD_TRAINING_STATEMENT === documentObject.type.key">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Szkolenie IDD</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.ofwca">
              <div fxFlex="100">
                <app-detail header="Szkolenie IDD"
                            [link]="documentObject.ofwca ? ['/szkolenia-idd/szczegoly', documentObject.iddTraining.uuid] : undefined">
                  IDD {{documentObject.iddTraining.year}} {{documentObject.iddTraining.ofwca.fullName}}
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_KRS_CEIDG,
        FILE_TYPE_PARTNER_DATA,
        FILE_TYPE_OVERCOMMISSION_AGREEMENT,
        FILE_TYPE_MANDATE_QUESTIONNAIRE
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Partner</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.partner">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="documentObject.partner.fullName"
                            [link]="documentObject.partner ? ['/partnerzy/szczegoly', documentObject.partner.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_KRK,
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>KRK</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.krk">
              <div fxFlex="100">
                <app-detail header="KRK" [value]="documentObject.krk.ofwca.fullName
                                          + ' (PESEL: ' + documentObject.ofwca.pesel + '), z dnia '
                                          + (documentObject.createdAt | date: 'y-MM-dd')"
                            [link]="documentObject.krk ? ['/krk/szczegoly', documentObject.krk.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
      FILE_TYPE_AUTHORIZATION,
      FILE_TYPE_CERT_40P,
      FILE_TYPE_ALLIANZ_CERT,
      FILE_TYPE_ALLIANZ_CERT_FRAUDS,
      FILE_TYPE_ALLIANZ_CERT_MY_CAR,
      FILE_TYPE_ALLIANZ_CERT_DOCUMENTS
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Rejestracja</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.registration">
              <div fxFlex="100">
                <app-detail header="Rejestracja" [value]="documentObject.registration.insuranceCompany.name
                                          + ' ' + documentObject.ofwca.fullName"
                            [link]="documentObject.registration ? ['/rejestracje/szczegoly', documentObject.registration.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_CERT_100P,
        FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU,
        FILE_TYPE_AML_CERTIFICATE
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.insuranceCompany">
              <div fxFlex="100">
                <app-detail header="TU" [value]="documentObject.insuranceCompany.name"
                            [link]="documentObject.insuranceCompany ? ['/tu/szczegoly', documentObject.insuranceCompany.id] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" *ngIf="documentObject.ofwca">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="documentObject.ofwca.fullName"
                            [link]="documentObject.ofwca ? ['/ofwca/szczegoly', documentObject.ofwca.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="[
        FILE_TYPE_INITIAL_TRAINING,
        FILE_TYPE_ANOTHER_MULTI
      ].includes(documentObject.type.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" *ngIf="documentObject.registration">
              <div fxFlex="100">
                <app-detail header="Rejestracja" [value]="documentObject.registration.insuranceCompany.name
                                          + ' ' + documentObject.ofwca.fullName"
                            [link]="documentObject.registration ? ['/rejestracje/szczegoly', documentObject.registration.uuid] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" *ngIf="documentObject.insuranceCompany">
              <div fxFlex="100">
                <app-detail header="TU" [value]="documentObject.insuranceCompany.name"
                            [link]="documentObject.insuranceCompany ? ['/tu/szczegoly', documentObject.insuranceCompany.id] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" *ngIf="documentObject.ofwca">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="documentObject.ofwca.fullName"
                            [link]="documentObject.ofwca ? ['/ofwca/szczegoly', documentObject.ofwca.uuid] : undefined">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
